import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { OrderedMap, Seq } from 'immutable';
import moment from 'moment';
import cx from 'classnames';

import Brand from 'models/brand';

import CurrencySymbol from 'components/common/currency-symbol';

const propTypes = {
  bookingId: PropTypes.number.isRequired,
  bookings: PropTypes.instanceOf(Seq.Keyed).isRequired,
  events: PropTypes.instanceOf(OrderedMap).isRequired,
  locations: PropTypes.instanceOf(OrderedMap).isRequired,
  cancelBooking: PropTypes.func.isRequired,
  brand: PropTypes.instanceOf(Brand).isRequired,
  locale: PropTypes.string.isRequired,
};

class BookingCancel extends Component {
  constructor(props) {
    super(props);

    this.state = {
      submitted: false,
    };

    this.cancel = this.cancel.bind(this);
  }

  cancel(e) {
    e.preventDefault();
    e.stopPropagation();

    const { bookings, bookingId, cancelBooking } = this.props;
    const booking = bookings.get(bookingId);

    if (booking.cancellable && !this.state.submitted) {
      cancelBooking({ booking });
      this.setState({
        submitted: true,
      });
    }
  }

  render() {
    const { bookings, locations, events, bookingId, brand, locale } = this.props;
    const { submitted } = this.state;
    const booking = bookings.get(bookingId);
    if (!booking || !booking.locationId) { return null; }

    const location = booking ? locations.get(booking.locationId.toString()) : null;
    if (!location) { return null; }

    const event = booking && booking.eventId ? events.get(booking.eventId.toString()) : null;

    const { timezone = 'America/Chicago' } = location || {};
    let time = booking.startTime ? booking.startTime.tz(timezone) : moment();
    time = time.locale(locale);

    const subTitle = event ? event.name : location.name;

    const passButtonClasses = cx({
      'btn': !brand.isBestParking,
      'btn-bp': brand.isBestParking,
      'btn-lg': true,
      'btn-alternate': true,
    });

    const refundAmount = (
      <Fragment>
        <CurrencySymbol location={location} />
        { booking.getFormattedPrice('pricePaid') }
      </Fragment>
    );

    return (
      <div className="light-content">
        <div className="row">
          <div className="col-xs-12 text-align-center">
            <div className="text-color-watermelon text-size-20 text-weight-medium margin-bottom-20">
              <FormattedMessage id="cancel.are-you-sure" defaultMessage="ARE YOU SURE YOU WANT TO CANCEL YOUR PARKING?" />
            </div>
            <div className="text-color-dark-slate text-weight-book text-size-18 margin-bottom-20">
              <FormattedMessage
                id="cancel.refund-amount"
                defaultMessage="Your total purchase of {refundAmount} will be refunded."
                values={{ refundAmount }}
              />
            </div>
          </div>
        </div>
        <div className="row text-color-dark-slate text-weight-book">
          <div className="col-xs-12">
            <div className="border-color-grey border-style-solid border-side-top margin-vertical-20" />
          </div>
          <div className="col-sm-6 col-xs-12 text-size-1">
            <div className="text-weight-bold ">{location.address}</div>
            <div>{subTitle}</div>
            <div>{time.format('dddd, MMMM D')} at <span className="text-weight-bold">{time.format('h:mma')}</span></div>
            <div className="margin-top-10">
              <FormattedMessage id="cancel.total-purchase" defaultMessage="TOTAL PURCHASE" /> <span className="text-weight-bold">
                <CurrencySymbol location={location} />
                {booking.getFormattedPrice('fullPrice')}
              </span>
            </div>
          </div>
          <div className="col-sm-6 col-xs-12 text-align-xs-left text-align-sm-right">
            <div className="margin-bottom-20">
              <FormattedMessage id="common.pass-number" defaultMessage="PARKING PASS #" />{booking.id}
            </div>
            <Link
              className={passButtonClasses}
              to={{
                pathname: `/ticket/${booking.id}`,
                search: `u=${booking.authorizationCode}`,
              }}
            >
              <FormattedMessage id="common.view-my-pass" defaultMessage="VIEW MY PASS" />
            </Link>
          </div>
          <div className="col-xs-12">
            <div className="border-color-grey border-style-solid border-side-top margin-vertical-20" />
          </div>
        </div>
        <div className="row margin-top-10">
          <div className="col-sm-6 col-sm-offset-3 col-md-4 col-md-offset-4 margin-bottom-20">
            <div
              className={`btn btn-lg btn-watermelon btn-block uppercase ${submitted ? 'disabled' : ''}`}
              onClick={this.cancel}
            >
              <FormattedMessage id="common.cancel-booking" defaultMessage="CANCEL BOOKING" />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 text-align-center text-weight-book">
            <Link
              to={{ pathname: '/account/' }}
            >
              <FormattedMessage id="common.go-back" defaultMessage="GO BACK" />
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

BookingCancel.propTypes = propTypes;
export default BookingCancel;
